module.exports = __webpack_public_path__ + "img/50.fb2f4a93.jpg";